import React from 'react'
import { Controller, Control, UseControllerProps } from 'react-hook-form'
import { DatePicker, DatePickerProps } from '@surecompanies/core_components'
import dayjs, { Dayjs } from 'dayjs'
import { Stack, TextColors, Typography } from '@sureco/design-system'

function toPickerValue(value: unknown): Dayjs | null {
  if (value == null || value === '') return null
  if (typeof value === 'string' || typeof value === 'number') {
    return dayjs(value)
  }
  if (dayjs.isDayjs(value)) return value
  return null
}

type RHFDatePickerProps = Omit<DatePickerProps, 'name'> & {
  name: string
  control: Control<any, object> // unable to make it work using generics yet Control<T>
  rules?: UseControllerProps['rules']
  label?: string
  isBeforeTodayAvailable?: boolean
}
export default function RHFDatePicker({
  name,
  control,
  rules,
  label,
  isBeforeTodayAvailable = true,
  ...rest
}: RHFDatePickerProps) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        return (
          <Stack space={2}>
            {label && <Typography>{label}</Typography>}
            <DatePicker
              name={field.name}
              status={fieldState.error ? 'error' : undefined}
              onBlur={field.onBlur}
              value={toPickerValue(field.value)}
              onChange={(date: Dayjs | null) => {
                field.onChange(date ? date.format('YYYY-MM-DD') : null)
              }}
              minDate={isBeforeTodayAvailable ? undefined : dayjs()}
              ref={field.ref}
              {...rest}
            />
            {fieldState.error && (
              <Typography color={TextColors.error}>
                {fieldState.error.message}
              </Typography>
            )}
          </Stack>
        )
      }}
    />
  )
}
